module.exports = __webpack_public_path__ + "images/numbered-list.9e56aeb41366851b98ba88f4ae50d49d.svg";